import { KeycloakContext } from './KeycloakContext'
import Keycloak from 'keycloak-js';
//import {useEffect, useState} from "react";
import {ApplicationInsights} from "@microsoft/applicationinsights-web";
import {ReactPlugin} from "@microsoft/applicationinsights-react-js";
import {ClickAnalyticsPlugin} from "@microsoft/applicationinsights-clickanalytics-js";

const reactPlugin = new ReactPlugin();
const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
    autoCapture: true
};

let appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING,
        enableDebug: false,
        autoTrackPageVisitTime: true,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
            [clickPluginInstance.identifier]: clickPluginConfig
        }
    }
});
// Set custom properties
appInsights.addTelemetryInitializer((telemetryItem) => {
    telemetryItem.tags = telemetryItem.tags || {};
    telemetryItem.tags['ai.cloud.role'] = 'Mimetika';
    telemetryItem.tags['ai.cloud.roleInstance'] = process.env.REACT_APP_DEPLOYMENT_SLOT;
});

appInsights.loadAppInsights();
appInsights.trackPageView({});


// Function to get URL parameter
//const getUrlParameter = (name) => {
//    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
//    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
//    const results = regex.exec(window.location.search);
//    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
//};




// Function to extract brand parameter from URL
function getBrandFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    let brandParam = urlParams.get('theme');
    const hostname = window.location.hostname;
    console.log("Detectect Hostname",hostname);

    let brandValue = 'mimetika-web';

    if (brandParam) {
        console.log("Theming via query:",brandParam);
        sessionStorage.setItem('theme', brandParam);
        brandValue = brandParam;
    } else {
        const storedBrand = sessionStorage.getItem('theme');
        if (storedBrand) {
            console.log("Theming via stored parameter:",storedBrand);
            brandValue = storedBrand;
        } else if (hostname.endsWith('indooptical.com')) {
            console.log("Theming via default mimetika host-URL:",hostname);

            brandValue = 'mimetika-web';
            sessionStorage.setItem('theme', brandValue);

        } else if (hostname.endsWith('gazeanalysis.com') ) {
            console.log("Theming via default mimetika host-URL:",hostname);

            brandValue = 'mimetika-web-wl1';
            sessionStorage.setItem('theme', brandValue);

        } else if (hostname.endsWith('optovision.com') ) {
            console.log("Theming via default mimetika host-URL:",hostname);

            brandValue = 'mimetika-web-ov';
            sessionStorage.setItem('theme', brandValue);
        }

        else if (hostname === 'localhost') {
            console.log("Theming via default mimetika host-URL:",hostname);

            brandValue = 'mimetika-web';
            sessionStorage.setItem('theme', brandValue);

        } else {
            console.error("Use default Theming as host URL is unknown:",hostname);
            brandValue = 'mimetika-web';
            sessionStorage.setItem('theme', brandValue);
        }
    }

    return brandValue;
}

const theme = getBrandFromUrl(); //getUrlParameter('theme') || 'mimetika-web';

let initOptions = {
    url: process.env.REACT_APP_KEYCLOAK_BASE_URL,
    realm: 'cnxt',
    clientId: theme,
    onLoad: 'check-sso',
};

const kc = new Keycloak(initOptions);
if(!kc.authenticated) {
    kc.init({
        onLoad: initOptions.onLoad,
    }).then((auth) => {
        if (!auth) {
        } else {
            //console.info("Authenticated");
            //console.log('auth', auth)
            //console.log('Keycloak', kc)
            kc.onTokenExpired = () => {
                console.log('token expired')
            }
        }
    }, () => {
        console.error("Authentication Failed");
        // appInsights.trackEvent({ name: "Authentication Failed"});
    });
}

export const KeycloakProvider = ({ children }) => {

    return (
        <KeycloakContext.Provider value={{ kc: kc, appInsights: appInsights, theme: theme }}>
            { children }
        </KeycloakContext.Provider>
    )
}
